// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundles/" + __webpack_require__.h() + "/" + ({"1869":"styles","2585":"intl-segmenter-polyfill","2702":"element-web-app","3444":"indexeddb.worker","4980":"blurhash.worker","5385":"init","5607":"error-view"}[chunkId] || chunkId) + ".js";
};